import { Button } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import IcBaselineAutoGraph from '~icons/ic/baseline-auto-graph'
import { cx } from 'src/utils/cx'
import { formatNum } from 'src/utils/formatNum'
import { track } from 'src/utils/tracker'

export function ModelRefCountInDialog(props: { refCount: number }) {
  return (
    // Using backdrop blur here will cause an Android Chrome rendering error
    <p className="absolute bottom-0 left-0 px-1 mlg:px-2 py-0.5 mlg:py-1 text-xs rounded-tr-lg rounded-bl-[0.69rem] text-white/70 bg-black/70">
      <IcBaselineAutoGraph className="mr-1 inline-block" />
      {formatNum(props.refCount)}
    </p>
  )
}

export function EmptyModelSearchResultsInDialog(
  props: {
    onGotoClick?: () => void
    showDescription?: boolean
    scene: 'lora' | 'model'
    actionType: 'go' | 'search'
  } & StyleProps,
) {
  const { t } = useTranslation(['generation'])
  return (
    <div
      className={cx(
        'flex flex-col items-center justify-center gap-4 mx-auto',
        props.className,
      )}
    >
      {props.showDescription && (
        <h1>{t('generation:lora.list.empty-placeholder')}</h1>
      )}
      <Button
        component={Link}
        to="/market"
        target="_blank"
        className="bg-theme-primary font-bold"
        variant="contained"
        onClick={e => {
          track('go_to_market_click', {
            fromPath: props.scene,
          })
          if (props.onGotoClick) {
            e.preventDefault()
            props.onGotoClick()
          }
        }}
      >
        {props.actionType === 'go'
          ? t('generation:lora.list.go-to-market')
          : t('generation:lora.list.search-in-market')}
      </Button>
    </div>
  )
}

export function EmptyModelListInSidebar(
  props: StyleProps & { mode: 'preset' | 'bookmark' },
) {
  const { t } = useTranslation(['generation'])
  return (
    <div
      className={cx(
        'flex flex-col items-center justify-center gap-4 mx-auto',
        props.className,
      )}
    >
      <p>
        {t(`generation:model.list.sidebar-empty-placeholder.${props.mode}`)}
      </p>
    </div>
  )
}

// This is necessary for VirutosoGrid to correctly calculate range
export const ModelListContainerInDialog = styled('div')(() => ({
  display: 'grid',
  width: 'calc(100% - 16px)',
  gridTemplateColumns: `repeat(auto-fill,minmax(120px,1fr))`,
  '@media (max-width: 600px)': {
    gridTemplateColumns: `repeat(auto-fill,minmax(80px,1fr))`,
  },
  gap: '0.75rem',
  marginTop: '1rem',
}))
